//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { queryMyEnrollList } from '@/https/enroll'
import TEnrollList from '@/TShareComponent/TEnrollList'

export default {
  components: { TEnrollList },

  props: {},

  data () {
    return {
      loading: false,
      enrollList: [],
      msg: '没有查询到您的报名信息！',
    }
  },

  computed: {},

  async created () {
    await this.setEnrollList()
  },

  methods: {
    async setEnrollList () {
      this.loading = true
      const { data } = await queryMyEnrollList()

      this.enrollList = data || []
      this.loading = false
    },

    goEnrollDetail (item) {
      this.$router.push('/enrollDetail')
    },
  },
}
